<template>
  <!-- <div v-if="!has_perm('view_service_package')">
    <div class="col-md-12">
      <h1 style="text-align: center; color: red;">
        {{ $t("common.not_permission") }} !
      </h1>
    </div>
  </div> -->
  <div v-if="has_perm('view_maintenance') || GET_ACCOUNT_DATA.group_id == 1">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t("search.title") }}</h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-sm-3 col-md-3 col-lg-3">
            <input
              type="text"
              class="form-control"
              :placeholder="$t('search.title')"
              v-model="search.searchText"
              @keydown.enter="onSearchMaintenance()"
            />
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="form-group">
              <div class="input-group date">
                <div class="input-group-addon">
                  <i class="fa fa-calendar">
                    <label>
                      <span style="margin-left:5px;display:inline-block;"
                        >{{ $t("service_history.date_from") }}:</span
                      >
                    </label>
                  </i>
                </div>
                <date-picker
                  :config="options"
                  :value="search.from_date"
                  v-model="search.from_date"
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="form-group">
              <div class="input-group date">
                <div class="input-group-addon">
                  <i class="fa fa-calendar">
                    <label>
                      <span style="margin-left:5px;display:inline-block;"
                        >{{ $t("service_history.date_to") }}:</span
                      >
                    </label>
                  </i>
                </div>
                <date-picker
                  :config="options"
                  :value="search.to_date"
                  v-model="search.to_date"
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3"
            v-if="maintenanceTabSelect !==
              maintenanceStatusEnum.MAINTENANCE_TRACKING">
            <div class="form-group">
              <v-select
                class="clear"
                :options="maintenanceTypeList"
                :getOptionLabel="option => option.default"
                :reduce="data => data.id"
                label="text"
                :placeholder="$t('propertyMaintenance.typeOfMaintenance')"
                v-model="search.maintenanceTypeValue"
              >
                <template v-slot:option="option">
                  {{ $t(option.default) }}
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 col-md-3 col-lg-3"></div>
          <div class="col-sm-3 col-md-3 col-lg-3"></div>
          <div class="col-sm-3 col-md-3 col-lg-3"></div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <button
              type="button"
              class="btn btn-labeled btn-success pull-right"
              @click="onSearchMaintenance()"
            >
              <span class="btn-label">
                <i class="glyphicon glyphicon-search"></i>
              </span>
              {{ $t("search.search_button") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="box box-primary">
        <div class="box-header">
          <h3 class="box-title" style="text-transform: capitalize;">
            {{ $t("propertyMaintenance.title") }}
          </h3>
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-12" style="text-align: right; margin-bottom: 15px">
              <!-- btn in tracking ui -->
              <button
                v-if="
                  maintenanceTabSelect !== null &&
                    maintenanceTabSelect ===
                      maintenanceStatusEnum.MAINTENANCE_TRACKING
                "
                type="button"
                class="btn btn-success btn-sm extra-tools"
                @click="onAddActivityTrackingAssetList"
              >
                <i class="glyphicon glyphicon-list-alt"></i>
                {{ $t("propertyMaintenance.activityPlan") }}
              </button>
              <button
                v-if="
                  maintenanceTabSelect !== null &&
                    maintenanceTabSelect ===
                      maintenanceStatusEnum.MAINTENANCE_TRACKING
                "
                type="button"
                class="btn btn-danger btn-sm extra-tools"
                @click="onRemoveActivityTrackingList"
              >
                <i class="glyphicon glyphicon-remove"></i>
                {{
                  $t("propertyMaintenance.removeAssetTrackingList.btnRemove")
                }}
              </button>
              <!--  -->
              <!-- btn in plan ui -->
              <button
                v-if="
                  maintenanceTabSelect !== null &&
                    maintenanceTabSelect ===
                      maintenanceStatusEnum.MAINTENANCE_PLANNING
                "
                type="button"
                class="btn btn-success btn-sm extra-tools"
                @click="onAddMaintenanceProcessing"
              >
                <i class="glyphicon glyphicon-plus"></i>
                {{ $t("propertyMaintenance.maintenanceInProcessing") }}
              </button>
              <button
                v-if="
                  maintenanceTabSelect !== null &&
                    maintenanceTabSelect ===
                      maintenanceStatusEnum.MAINTENANCE_PLANNING
                "
                type="button"
                class="btn btn-danger btn-sm extra-tools"
                @click="onRemoveActivityPlanList"
              >
                <i class="glyphicon glyphicon-remove"></i>
                {{
                  $t("propertyMaintenance.removeAssetTrackingList.btnRemove")
                }}
              </button>
              <!--  -->
              <button
                type="button"
                class="btn btn-primary btn-sm extra-tools"
                @click="exportActivity"
              >
                <i class="glyphicon glyphicon-open"></i>
                {{ $t("common.exportFileExcel") }}
              </button>
              <button
                v-if="
                  maintenanceTabSelect !== null &&
                    maintenanceTabSelect ===
                      maintenanceStatusEnum.MAINTENANCE_TRACKING
                "
                type="button"
                class="btn btn-success btn-sm extra-tools"
                @click="importActivityTrackingExcel"
              >
                <i class="glyphicon glyphicon-save"></i>
                {{ $t("common.importFileExcel") }}
              </button>
              <button
                v-if="
                  has_perm('create_maintenance') &&
                    maintenanceTabSelect !== null &&
                    maintenanceTabSelect ===
                      maintenanceStatusEnum.MAINTENANCE_PLANNING
                "
                type="button"
                class="btn btn-primary btn-sm extra-tools"
                @click="onOpenAddIncident"
              >
                <i class="glyphicon glyphicon-plus"></i>
                {{ $t("propertyMaintenance.addIncidentReport") }}
              </button>
              <button
                v-if="
                  has_perm('create_maintenance') &&
                    maintenanceTabSelect ===
                      maintenanceStatusEnum.MAINTENANCE_IN_PROCESSING
                "
                type="button"
                class="btn btn-info btn-sm extra-tools"
                data-toggle="dropdown"
              >
                <i class="glyphicon glyphicon-plus"></i>
                {{ $t("common.addnew") }}
              </button>
              <ul
                class="dropdown-menu pull-right"
                role="menu"
                style="margin-top: 5px; text-align: center; max-height: 300px; overflow-y: auto; right: 15px"
                aria-labelledby="dropdownMenuButton"
              >
                <li
                  v-for="(maintenanceTypeItem, index) in maintenanceTypeList"
                  :key="index"
                  style="padding: 8px; cursor: pointer;"
                  @click="onOpenAddInput(maintenanceTypeItem.id)"
                  class="add-maintenance-process-item"
                >
                  {{ maintenanceTypeItem.default }}
                </li>
              </ul>
              <button
                v-if="
                  has_perm('create_maintenance') &&
                    maintenanceTabSelect ===
                      maintenanceStatusEnum.MAINTENANCE_TRACKING
                "
                type="button"
                class="btn btn-info btn-sm extra-tools"
                @click="onOpenAddActivityTracking"
              >
                <i class="glyphicon glyphicon-plus"></i>
                {{ $t("common.addnew") }}
              </button>
              <button
                v-if="
                  has_perm('create_maintenance') &&
                    maintenanceTabSelect ===
                      maintenanceStatusEnum.MAINTENANCE_PLANNING
                "
                type="button"
                class="btn btn-info btn-sm extra-tools"
                @click="onOpenAddActivityPlan"
              >
                <i class="glyphicon glyphicon-plus"></i>
                {{ $t("common.addnew") }}
              </button>
            </div>
            <div class=""
              style="
                display: flex;
                padding: 0 15px;
              "
            >
              <span
                v-for="(item, index) in maintenanceTabList"
                :key="item + index"
                :class="
                  `${
                    index !== maintenanceTabList.length - 1
                      ? 'customer-type-class border-right'
                      : 'customer-type-class'
                  }`
                "
                @click="onChangeTab(item.value)"
              >
                <span
                  :class="
                    item.value === maintenanceTabSelect
                      ? 'customer-type-select'
                      : ''
                  "
                  style="white-space: nowrap;"
                >
                  {{ $t(item.text) }}
                  <!-- ({{ item.total }}) -->
                </span>
              </span>
            </div>
            <hr 
              v-if="maintenanceTabSelect === null" 
              style="margin-top: 7.5px; margin-bottom: 7.5px;">
            <div v-show="maintenanceTabSelect === null" class="" style="display: flex; padding: 0 15px">
              <span
                v-for="(item, index) in historyTabList"
                :key="item + index"
                :class="
                  `${
                    index !== historyTabList.length - 1
                      ? 'customer-type-class border-right'
                      : 'customer-type-class'
                  }`
                "
                @click="onChangeHistoryTab(item.value)"
              >
                <span
                  :class="
                    item.value === historyTabSelect
                      ? 'customer-type-select'
                      : ''
                  "
                  style="white-space: nowrap;"
                >
                  {{ $t(item.text) }}
                  <!-- ({{ item.total }}) -->
                </span>
              </span>
            </div>
            <div
              class="col-md-12"
              v-show="
                maintenanceTabSelect ===
                  maintenanceStatusEnum.MAINTENANCE_TRACKING
              "
            >
              <activity-tracking-list ref="activityTrackingList" />
            </div>
            <div
              class="col-md-12"
              v-show="
                maintenanceTabSelect ===
                  maintenanceStatusEnum.MAINTENANCE_PLANNING
                || (historyTabSelect === maintenanceStatusEnum.MAINTENANCE_PLANNING
                  && maintenanceTabSelect === null)
              "
            >
              <activity-plan-list 
                ref="activityPlanList" 
                :historyTabSelect="historyTabSelect"
                :maintenanceTabSelect="maintenanceTabSelect"
                />
            </div>
            <div
              v-show="
                maintenanceTabSelect ===
                  maintenanceStatusEnum.MAINTENANCE_IN_PROCESSING ||
                  (maintenanceTabSelect === null 
                    && historyTabSelect === maintenanceStatusEnum.MAINTENANCE_IN_PROCESSING)
              "
              class="col-md-12"
            >
              <b-table
                :items="maintenanceList"
                :fields="maintenanceFields"
                :tbody-tr-class="rowClass"
                class="mt-3 package-table"
                responsive
                outlined
              >
                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
                <template #cell(status)="row">
                  {{ $t(getmaintenanceStatus(row.item.status)) }}
                </template>
                <template #cell(maintenanceDescription)="row">
                  {{
                    spliceString(
                      row.item.maintenanceDescription,
                      row.item.status ===
                        maintenanceStatusEnum.MAINTENANCE_TRACKING
                        ? 75
                        : 25
                    )
                  }}
                </template>
                <template #cell(maintenanceTitle)="row">
                  <div class="parent">
                    {{
                      spliceString(
                        row.item.maintenanceTitle,
                        row.item.status ===
                          maintenanceStatusEnum.MAINTENANCE_TRACKING
                          ? 50
                          : 15
                      )
                    }}
                    <div
                      v-if="has_perm('update_maintenance')"
                      class="show-when-hovered"
                      style="display: flex; white-space: nowrap;"
                    >
                      <span
                        v-if="
                          maintenanceTabSelect ===
                            maintenanceStatusEnum.MAINTENANCE_TRACKING &&
                            row.item.status ===
                              maintenanceStatusEnum.MAINTENANCE_TRACKING
                        "
                        class="payment-status hover-action"
                        @click="
                          maintenanceAction(
                            maintenanceStatusEnum.MAINTENANCE_PLANNING,
                            row.item
                          )
                        "
                        ><small>{{
                          $t("propertyMaintenance.activity")
                        }}</small></span
                      >
                      <span
                        v-if="
                          maintenanceTabSelect ===
                            maintenanceStatusEnum.MAINTENANCE_TRACKING &&
                            row.item.status ===
                              maintenanceStatusEnum.MAINTENANCE_TRACKING
                        "
                        class="action-space-border"
                        >|</span
                      >
                      <span
                        v-if="
                          maintenanceTabSelect ===
                            maintenanceStatusEnum.MAINTENANCE_PLANNING &&
                            row.item.status ===
                              maintenanceStatusEnum.MAINTENANCE_PLANNING
                        "
                        class="payment-status hover-action"
                        @click="
                          startMaintenanceAsset(
                            maintenanceStatusEnum.MAINTENANCE_IN_PROCESSING,
                            row.item
                          )
                        "
                        ><small>{{ $t("common.actionStart") }}</small></span
                      >
                      <span
                        v-if="
                          maintenanceTabSelect ===
                            maintenanceStatusEnum.MAINTENANCE_PLANNING &&
                            row.item.status ===
                              maintenanceStatusEnum.MAINTENANCE_PLANNING
                        "
                        class="action-space-border"
                        >|</span
                      >
                      <!--  -->
                      <!-- <span
                        v-if="
                          maintenanceTabSelect === 1 &&
                            row.item.approval === approvalEnum.WAITING_APPROVAL
                        "
                        class="payment-status hover-action"
                        @click="
                          onShowUpdateStatus(approvalEnum.APPROVED, row.item)
                        "
                        ><small>{{ $t("common.approval") }}</small></span
                      >
                      <span
                        v-if="
                          maintenanceTabSelect === 1 &&
                            row.item.approval === approvalEnum.WAITING_APPROVAL
                        "
                        class="action-space-border"
                        >|</span
                      ><span
                        v-if="
                          maintenanceTabSelect === 1 &&
                            row.item.approval === approvalEnum.WAITING_APPROVAL
                        "
                        class="completed-status hover-action"
                        @click="
                          onShowUpdateStatus(approvalEnum.UNAPPROVED, row.item)
                        "
                        ><small>{{ $t("common.notApproval") }}</small></span
                      >
                      <span
                        v-if="
                          maintenanceTabSelect === 1 &&
                            row.item.approval === approvalEnum.WAITING_APPROVAL
                        "
                        class="action-space-border"
                        >|</span
                      > -->
                      <span
                        class="detail-service hover-action"
                        @click="onShowDetail(row)"
                        ><small>{{ $t("common.detail") }}</small></span
                      >
                      <span
                        class="action-space-border"
                        v-if="
                          row.item.status ===
                            maintenanceStatusEnum.MAINTENANCE_TRACKING ||
                            row.item.status ===
                              maintenanceStatusEnum.MAINTENANCE_PLANNING
                        "
                        >|</span
                      >
                      <span
                        v-if="
                          row.item.status ===
                            maintenanceStatusEnum.MAINTENANCE_TRACKING
                        "
                        class="cancel-status hover-action"
                        @click="onDeleteMaintenance(row.item)"
                        ><small>{{ $t("common.delete") }}</small></span
                      >
                      <span
                        v-if="
                          row.item.status ===
                            maintenanceStatusEnum.MAINTENANCE_PLANNING
                        "
                        class="cancel-status hover-action"
                        @click="onShowConfirmCancelMaintenance(row.item)"
                        ><small>{{ $t("common.cancel") }}</small></span
                      >
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div
          class="box-footer"
          v-if="
            maintenanceTabSelect ===
              maintenanceStatusEnum.MAINTENANCE_IN_PROCESSING
          "
        >
          <div class="row">
            <div class="col-md-12">
              <paginator
                :totalItem="paginateData.totalItem"
                :currentPage="paginateData.currentPage"
                :pageSize="paginateData.pageSize"
                :totalPage="paginateData.totalPage"
                @onpaginate="onPagination"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Modal Confirm Delete -->
      <div class="modal fade" :ref="`modal-pkg-tmpl`">
        <div class="modal-dialog">
          <confirm :id="pkg_tmpl_data.id" @confirm="onDeleteConfirm" />
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
    </div>
    <div
      class="modal fade"
      :ref="`modal-update-service-status`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onCloseMaintenanceModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t(modalConfirmTitle) }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                {{ $t(modalConfirmContent) }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseMaintenanceModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onUpdateStatusServiceOrder"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!--  -->
    <maintenance-modal
      ref="maintenanceModal"
      @callbackMaintenanceList="onSearchMaintenance"
    />
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>

    <lte-modal
      v-show="isShowModalCancelMaintenance"
      @onConfirm="onConfirmCancelMaintenance"
      @close="closeModalCancelMaintenance"
      v-for="obj in objModalCancelMaintenance"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
// import RegisterVehicleInputView from './RegisterVehicleInputView'
// import moment from "moment"
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Confirm from "@/components/Confirm.vue";
import Paginator from "@/components/CustomPaginator.vue";
import ActivityTrackingList from "./ActivityTrackingList";
import ActivityPlanList from "./ActivityPlanList";
// import Loading from "vue-loading-overlay"
import utils from "@/lib/utils";
import ServiceOrderStatusEnum from "@/enum/serviceOrderStatusEnum";
import MaintenanceModal from "./MaintenanceModal";
import Enum from "../../../enum/enum";
import constantsData from "@/lib/constantsData";
import LTEModal from "@/components/LTEModal.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import XLSX from "xlsx";

export default {
  name: "PackageTemplateView",
  data() {
    return {
      isLoading: false,
      ServiceOrderStatusEnum: ServiceOrderStatusEnum,
      search: {
        searchText: null,
        from_date: null,
        to_date: null,
        maintenanceTypeValue: null,
        isGetHistory: false
      },
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      maintenanceTabSelect: Enum.MaintenanceStatusEnum.MAINTENANCE_TRACKING,
      maintenanceTabList: [
        // { value: null, text: "project.all", total: 0 },
        {
          value: Enum.MaintenanceStatusEnum.MAINTENANCE_TRACKING,
          text: "propertyMaintenance.maintenanceTracking",
          total: 0
        },
        {
          value: Enum.MaintenanceStatusEnum.MAINTENANCE_PLANNING,
          text: "propertyMaintenance.maintenancePlan",
          total: 0
        },
        {
          value: Enum.MaintenanceStatusEnum.MAINTENANCE_IN_PROCESSING,
          text: "propertyMaintenance.maintenanceInProcessing",
          total: 0
        },
        {
          value: null,
          text: "common.history",
          total: 0
        }
      ],
      //
      pkg_tmpl_data: {
        id: 0
      },
      maintenanceList: [],
      maintenanceFields: [],
      //
      maintenanceInProcessingFields: [
        {
          key: "nonumber",
          label: "common.nonumber",
          sortable: false,
          class: "text-center"
        },
        {
          key: "dateCreate",
          label: "common.dateCreate",
          sortable: false
        },
        {
          key: "maintenanceCode",
          label: "common.code",
          sortable: false
        },
        {
          key: "maintenanceTitle",
          label: "propertyMaintenance.maintenanceTitle",
          sortable: false
        },
        {
          key: "maintainanceStartDate",
          label: "propertyMaintenance.implementationDate",
          sortable: false
        },
        {
          key: "typeOfMaintenance",
          label: "propertyMaintenance.typeOfMaintenance",
          sortable: false
        },
        {
          key: "maintenancePersonnel",
          label: "propertyMaintenance.assignTo",
          sortable: false
        },
        {
          key: "status",
          label: "propertyMaintenance.activity",
          sortable: false
        }
      ],
      maintenanceHistoryFields: [
        {
          key: "nonumber",
          label: "common.nonumber",
          sortable: false,
          class: "text-center"
        },
        {
          key: "maintenanceCode",
          label: "common.code",
          sortable: false
        },
        {
          key: "maintenanceTitle",
          label: "propertyMaintenance.maintenanceTitle",
          sortable: false
        },
        {
          key: "maintainanceStartDate",
          label: "propertyMaintenance.implementationDate",
          sortable: false
        },
        {
          key: "typeOfMaintenance",
          label: "propertyMaintenance.typeOfMaintenance",
          sortable: false
        },
        {
          key: "maintenancePersonnel",
          label: "propertyMaintenance.assignTo",
          sortable: false
        },
        {
          key: "status",
          label: "propertyMaintenance.activity",
          sortable: false
        }
      ],
      //
      paginateData: {
        totalItem: 1,
        currentPage: 1,
        pageSize: 1,
        totalPage: 1
      },
      //
      modalConfirmTitle: "",
      modalConfirmContent: "",
      maintenanceSelect: null,
      maintenanceUpdateStatus: null,
      approvalEnum: Enum.MaintenanceApprovalEnum,
      maintenanceStatusList: constantsData.maintenanceStatusList,
      objModal: [
        {
          title: "common.delete_modal.title",
          body: "common.delete_modal.content",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      isModalVisible: false,
      originalRecordData: null,
      maintenanceStatusEnum: Enum.MaintenanceStatusEnum,
      isShowModalCancelMaintenance: false,
      objModalCancelMaintenance: [
        {
          title: "propertyMaintenance.notiCancelMaintenanceTitle",
          body: "propertyMaintenance.notiCancelMaintenance",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      exportExcelData: {
        headerList: [
          [this.$t("common.dateCreate")],
          [this.$t("common.code")],
          [this.$t("propertyMaintenance.assetCode")],
          [this.$t("property.name")],
          [this.$t("property.asset.location")],
          [this.$t("property.asset.maintainance_repeat_option")],
          [this.$t("propertyMaintenance.lastImplementationeDate")],
          [this.$t("propertyMaintenance.nextImplementationDate")],
          [this.$t("propertyMaintenance.scheduledMaintenanceDate")],
          [this.$t("propertyMaintenance.implementationDate")],
          [this.$t("propertyMaintenance.assignTo")],
          [this.$t("common.email")],
          [this.$t("propertyMaintenance.activity")]
        ],
        dataList: []
      },
      maintenanceTypeList: [],
      historyTabList: [
        {
          value: Enum.MaintenanceStatusEnum.MAINTENANCE_PLANNING,
          text: "propertyMaintenance.maintenanceHistory.maintenancePlan",
          total: 0
        },
        {
          value: Enum.MaintenanceStatusEnum.MAINTENANCE_IN_PROCESSING,
          text: "propertyMaintenance.maintenanceInProcessing",
          total: 0
        }
      ],
      historyTabSelect: Enum.MaintenanceStatusEnum.MAINTENANCE_PLANNING
    };
  },
  watch: {
    // GET_NUMBER_SERVICE_ORDER_LIST_DATA: function() {
    //   let data = this.GET_NUMBER_SERVICE_ORDER_LIST_DATA;
    //   data.forEach(v => {
    //     let index = this.maintenanceTabList.findIndex(
    //       x => x.value === v.value
    //     );
    //     if (index !== -1) {
    //       this.maintenanceTabList[index].total = v.total;
    //     }
    //   });
    // },
    GET_MAINTENANCE_LIST_DATA: function() {
      let paginate = this.GET_MAINTENANCE_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_MAINTENANCE_LIST_DATA.results;
      this.maintenanceList = [];
      data.forEach((v, i) => {
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let item = {
          id: v.id,
          nonumber: nonumber,
          maintainanceStartDate: utils.formatSqlDate(v.maintainance_date, null, "DD/MM/YYYY"),
          maintenanceCode: v.code,
          maintenanceTitle: v.title,
          maintenanceDescription: v.description,
          typeOfMaintenance: utils.isEmptyString(v.maintenance_function_data.name)
            ? v.maintenance_type_data.name : `${v.maintenance_type_data.name} - ${v.maintenance_function_data.name}`,
          status: v.status,
          maintenancePersonnel: v.contacter.full_name,
          // assetId: v.asset_data.id,
          approval: v.approval,
          maintenanceTypeValue: v.maintenance_type,
          maintenanceFunctionValue: v.maintenance_function,
          contacterId: v.contacter.id,
          dateCreate: utils.formatSqlDate(v.date_created, null, "DD/MM/YYYY"),
          lastMaintenanceDate: utils.formatSqlDate(v.last_maintenance_date, null, "DD/MM/YYYY"),
          nextMaintainanceDate: utils.formatSqlDate(v.next_maintainance_date, null, "DD/MM/YYYY"),
          scheduledMaintenanceDate: utils.formatSqlDate(v.scheduled_maintenance_date, null, "DD/MM/YYYY")
        };
        this.maintenanceList.push(item);
      });
    },
    GET_MAINTENANCE_TYPE_LIST_DATA: function() {
      let data = this.GET_MAINTENANCE_TYPE_LIST_DATA;
      this.maintenanceTypeList = data;
    }
  },
  computed: {
    ...mapGetters([
      // "GET_NUMBER_SERVICE_ORDER_LIST_DATA",
      "GET_MAINTENANCE_LIST_DATA",
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ACCOUNT_DATA",
      "GET_MAINTENANCE_TYPE_LIST_DATA"
    ])
  },
  methods: {
    rowClass: function(item, type) {
      if (!item || type !== "row") return;
      if (item.status === Enum.MaintenanceStatusEnum.MAINTENANCE_CANCELED) {
        return "description-width maintenance-cancel-class-bg";
      } else return "description-width";
    },
    spliceString: function(strText, len) {
      return utils.spliceString(strText, len);
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    formatNumber: function(n) {
      return utils.formatNumber(n);
    },
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    onOpenAddInput: function(value) {
      this.$refs.maintenanceModal.addNew(
        this.maintenanceTabSelect,
        null,
        null,
        value
      );
    },
    onShowDetail: function(row) {
      this.$refs.maintenanceModal.showDetail(
        row.item,
        this.maintenanceTabSelect
      );
    },
    onOpenDeletePakageTemplateConfirm: function(row) {
      this.pkg_tmpl_data.id = row.item.id;
      this.onToggleDeleteConfirm();
    },
    onToggleDeleteConfirm: function(action = "show") {
      $(this.$refs[`modal-pkg-tmpl`]).modal(action);
    },
    onDeleteConfirm: function(id) {
      const payload = {
        id: id
      };
      this.DELETE_PACKAGE_TEMPLATE(payload).then(
        function() {
          this.onToggleDeleteConfirm("hide");
          this.GET_PACKAGE_TEMPLATE_LIST();
        }.bind(this)
      );
    },
    onPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getMaintenanceList(data);
    },
    //
    onSearchMaintenance: function() {
      this.search.isGetHistory = false
      this.search.searchText = utils.getCleanStringValue(this.search.searchText)
      if (this.maintenanceTabSelect === Enum.MaintenanceStatusEnum.MAINTENANCE_TRACKING) {
        if (this.$refs.activityTrackingList !== undefined) {
          this.$refs.activityTrackingList.onRefreshData(this.search);
        }
      } else if (this.maintenanceTabSelect === Enum.MaintenanceStatusEnum.MAINTENANCE_PLANNING) {
        if (this.$refs.activityPlanList !== undefined) {
          this.$refs.activityPlanList.onRefreshData(this.search);
        }
      } else if (this.maintenanceTabSelect === Enum.MaintenanceStatusEnum.MAINTENANCE_IN_PROCESSING) {
        this.getMaintenanceList(1);
      } else {
        // this.getMaintenanceList(1);
        this.onChangeHistoryTab(this.historyTabSelect)
      }
      // this.getNumberServiceOrder();
    },
    getMaintenanceList: function(page) {
      let statusList = null;
      if (this.maintenanceTabSelect === null) {
        statusList = [
          Enum.MaintenanceStatusEnum.MAINTENANCE_FINISHED,
          Enum.MaintenanceStatusEnum.MAINTENANCE_CANCELED
        ];
      } else {
        statusList = [this.maintenanceTabSelect];
      }
      let filter = {
        params: {
          page: page,
          statusList: statusList,
          searchText: utils.getCleanStringValue(this.search.searchText),
          fromDate: utils.formatSqlUtcDate(this.search.from_date, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          toDate: utils.formatSqlUtcDate(this.search.to_date, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          maintenanceTypeValue: this.search.maintenanceTypeValue,
          isGetHistory: this.search.isGetHistory
        }
      };
      this.isLoading = true;
      this.GET_MAINTENANCE_LIST(filter).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    onChangeTab: function(value) {
      this.maintenanceTabSelect = value;
      this.search.isGetHistory = false
      if (value === Enum.MaintenanceStatusEnum.MAINTENANCE_TRACKING) {
        if (this.$refs.activityTrackingList !== undefined) {
          this.$refs.activityTrackingList.onRefreshData(this.search);
        }
      } else if (value === Enum.MaintenanceStatusEnum.MAINTENANCE_PLANNING) {
        if (this.$refs.activityPlanList !== undefined) {
          this.$refs.activityPlanList.onRefreshData(this.search);
        }
      } else if (
        value === Enum.MaintenanceStatusEnum.MAINTENANCE_IN_PROCESSING
      ) {
        this.maintenanceFields = this.maintenanceInProcessingFields;
        this.getMaintenanceList(1);
      } else {
        this.maintenanceFields = this.maintenanceHistoryFields;
        this.onChangeHistoryTab(this.historyTabSelect)
        // this.getMaintenanceList(1);
      }
    },
    // getNumberServiceOrder: function() {
    //   this.GET_NUMBER_SERVICE_ORDER_LIST();
    // },
    onCloseMaintenanceModal: function() {
      $(this.$refs[`modal-update-service-status`]).modal("hide");
    },
    onShowMaintenanceModal: function() {
      $(this.$refs[`modal-update-service-status`]).modal("show");
    },
    onShowUpdateStatus: function(statusValue, data) {
      if (statusValue === this.approvalEnum.UNAPPROVED) {
        this.modalConfirmTitle = "propertyMaintenance.confirmNotApproval";
        this.modalConfirmContent =
          "propertyMaintenance.confirmNotApprovalContent";
      } else if (statusValue === this.approvalEnum.APPROVED) {
        this.modalConfirmTitle = "propertyMaintenance.confirmApproval";
        this.modalConfirmContent = "propertyMaintenance.confirmApprovalContent";
      }
      this.maintenanceSelect = data;
      this.maintenanceUpdateStatus = statusValue;
      this.onShowMaintenanceModal();
    },
    onUpdateStatusServiceOrder: function() {
      let data = {
        id: this.maintenanceSelect && this.maintenanceSelect.id,
        approval: this.maintenanceUpdateStatus
      };
      this.isLoading = true;
      this.POST_APPROVAL_OR_NOT_APPROVAL_MAINTENANCE(data)
        .then(
          function() {
            this.SUCCESS_TOAST();
            this.getMaintenanceList(this.paginateData.currentPage);
            // this.getNumberServiceOrder();
            this.onCloseMaintenanceModal();
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    getMaintenanceTypeList: function() {
      this.GET_MAINTENANCE_TYPE_LIST();
    },
    getAssetList: function() {
      let filter = {
        params: {
          // isGetApartmentAsset: "True"
        }
      };
      this.GET_ASSET_LIST_V2(filter);
    },
    getUserList: function() {
      this.GET_USER_LIST();
    },
    getmaintenanceStatus: function(value) {
      let index = this.maintenanceStatusList.findIndex(x => x.value === value);
      return index !== -1 ? this.maintenanceStatusList[index].text : "";
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onDeleteMaintenance: function(data) {
      this.isModalVisible = true;
      this.originalRecordData = data;
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_MAINTENANCE(this.originalRecordData)
        .then(
          function() {
            this.getMaintenanceList(this.paginateData.currentPage);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    maintenanceAction: function(actionType, data) {
      this.$refs.maintenanceModal.maintenanceAssetAction(actionType, data);
    },
    startMaintenanceAsset: function(actionType, data) {
      this.$refs.maintenanceModal.maintenanceAssetAction(actionType, data);
    },
    onShowConfirmCancelMaintenance: function(data) {
      this.isShowModalCancelMaintenance = true;
      this.originalRecordData = data;
    },
    closeModalCancelMaintenance: function() {
      this.isShowModalCancelMaintenance = false;
    },
    onConfirmCancelMaintenance: function() {
      this.$refs.maintenanceModal.maintenanceCancelAction(
        Enum.MaintenanceStatusEnum.MAINTENANCE_CANCELED,
        this.originalRecordData
      );
      this.isShowModalCancelMaintenance = false;
    },
    // export excel
    exportActivity: function() {
      if (
        this.maintenanceTabSelect === Enum.MaintenanceStatusEnum.MAINTENANCE_IN_PROCESSING 
          || (this.maintenanceTabSelect === null && 
          this.historyTabSelect === Enum.MaintenanceStatusEnum.MAINTENANCE_IN_PROCESSING)) {
            this.exportAssetExcel()
      } else if (this.maintenanceTabSelect === Enum.MaintenanceStatusEnum.MAINTENANCE_TRACKING) {
        this.$refs.activityTrackingList.exportExcel()
      }
    },
    exportAssetExcel: function() {
      let statusList = null;
      if (this.maintenanceTabSelect === null) {
        statusList = [
          Enum.MaintenanceStatusEnum.MAINTENANCE_FINISHED,
          Enum.MaintenanceStatusEnum.MAINTENANCE_CANCELED
        ];
      } else {
        statusList = [this.maintenanceTabSelect];
      }
      let filter = {
        params: {
          statusList: statusList,
          searchText: utils.getCleanStringValue(this.search.searchText),
          fromDate: utils.formatSqlUtcDate(this.search.from_date, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          toDate: utils.formatSqlUtcDate(this.search.to_date, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          maintenanceTypeValue: this.search.maintenanceTypeValue,
          isGetHistory: this.search.isGetHistory
        }
      };
      this.isLoading = true;
      this.GET_MAINTENANCE_LIST(filter)
        .then(
          async function(res) {
            this.isLoading = false;
            let dataList = this.getDataExcelJson(
              this.exportExcelData.headerList,
              res
            );
            await this.createAssetExcelFile(dataList);
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    getDataExcelJson: function(headerList, dataList) {
      let resultList = [];
      //
      // [this.$t("propertyMaintenance.assetCode")],
      // [this.$t("property.name")],
      // [this.$t("property.asset.location")],
      // [this.$t("property.asset.maintainance_repeat_option")],
      // [this.$t("property.asset.lastMaintenanceDate")],
      // [this.$t("property.asset.nextMaintainanceDate")],
      // [this.$t("propertyMaintenance.scheduledMaintenanceDate")],
      // [this.$t("property.asset.maintainance_start_date")],
      // let headerListLength = headerList.length
      let dateCreateHeader = headerList[0];
      let maintenanceCodeHeader = headerList[1];
      let assetCodeHeader = headerList[2];
      let assetNameHeader = headerList[3];
      let assetLocationHeader = headerList[4];
      let maintainanceRepeatOption = headerList[5];
      let lastMaintenanceDate = headerList[6];
      let nextMaintainanceDate = headerList[7];
      let scheduledMaintenanceDate = headerList[8];
      let maintainanceStartDate = headerList[9];
      let maintenancePersonnelHeader = headerList[10];
      let maintenancePersonnelEmailHeader = headerList[11];
      let statusHeader = headerList[12];

      dataList.forEach(data => {
        // let maintainance_repeat_option =
        //   data.maintenance_type === 1
        //     ? this.$t("property.asset.maintenanceOnce")
        //     : this.$t("property.asset.cyclical");

        // let asset_status = data.asset_status_data.name;

        let dateCreate = utils.formatSqlDate(data.date_created, null, "DD/MM/YYYY");
        let lastMaintenanceDateData = utils.formatSqlDate(data.last_maintenance_date, null, "DD/MM/YYYY");
        let nextMaintainanceDateData = utils.formatSqlDate(data.next_maintainance_date, null, "DD-MM-YYYY");
        let scheduledMaintenanceDateData = utils.formatSqlDate(data.scheduled_maintenance_date, null, "DD/MM/YYYY");
        let maintainanceStartDateData = utils.formatSqlDate(data.maintainance_date, null, "DD/MM/YYYY");
        let statusData = this.$t(this.getmaintenanceStatus(data.status));
        let maintenancePersonnelData = data.contacter.full_name;
        let maintenancePersonnelEmailData = data.contacter.email;
        let item = {
          [dateCreateHeader]: dateCreate,
          [maintenanceCodeHeader]: data.code,
          [assetCodeHeader]: null,
          [assetNameHeader]: null,
          [assetLocationHeader]: null,
          [maintainanceRepeatOption]: null,
          [lastMaintenanceDate]: lastMaintenanceDateData,
          [nextMaintainanceDate]: nextMaintainanceDateData,
          [scheduledMaintenanceDate]: scheduledMaintenanceDateData,
          [maintainanceStartDate]: maintainanceStartDateData,
          [maintenancePersonnelHeader]: maintenancePersonnelData,
          [maintenancePersonnelEmailHeader]: maintenancePersonnelEmailData,
          [statusHeader]: statusData
        };
        // get asset list
        let assetList = data.asset_list_data;
        assetList.forEach(assetItem => {
          let assetName = assetItem.name;
          let assetCode = assetItem.code;
          let assetLocation = assetItem.location;
          let assetMaintenanceType =
            assetItem.maintenance_type === 1
              ? this.$t("property.asset.maintenanceOnce")
              : this.$t("property.asset.cyclical");
          item[assetCodeHeader] = assetCode;
          item[assetNameHeader] = assetName;
          item[assetLocationHeader] = assetLocation;
          item[maintainanceRepeatOption] = assetMaintenanceType;
          // push item
          resultList.push(item);
        });
      });
      return resultList;
    },
    createAssetExcelFile: function(jsonData) {
      let data_list = [];

      data_list = jsonData;
      // export json to Worksheet of Excel
      // only array possible
      var assetFile = XLSX.utils.json_to_sheet(data_list);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, assetFile, "maintenanceList"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "MaintenanceList.xlsx"); // name of the file is 'book.xlsx'
    },
    // import excel file
    importActivityTrackingExcel: function() {
      this.$router.push({
        name: "ImportActivityTracking"
      });
    },
    // onOpenAddIncident: function() {
    //   this.$refs.maintenanceModal.addNew(
    //     Enum.MaintenanceStatusEnum.MAINTENANCE_PLANNING,
    //     null,
    //     true
    //   );
    // },
    // onOpenAddActivityTracking: function() {
    //   this.$refs.activityTrackingList.addAssetActivityTracking();
    // },
    // onOpenAddActivityPlan: function() {
    //   this.$refs.activityPlanList.addAssetActivityTracking();
    // },
    // tracking
    onOpenAddActivityTracking: function() {
      this.$refs.activityTrackingList.addAssetActivityTracking(null);
    },
    onAddActivityTrackingAssetList: function() {
      this.$refs.activityTrackingList.onShowConfirmAddActivityPlanAssetList();
    },
    onRemoveActivityTrackingList: function() {
      this.$refs.activityTrackingList.onRemoveActivityTrackingList();
    },
    // plan
    onOpenAddIncident: function() {
      // this.$refs.maintenanceModal.addNew(
      //   Enum.MaintenanceStatusEnum.MAINTENANCE_PLANNING,
      //   null,
      //   true
      // );
      this.$refs.activityPlanList.addAssetActivityTracking(Enum.MaintenanceTypeEnum.INCIDENT);
    },
    onOpenAddActivityPlan: function() {
      this.$refs.activityPlanList.addAssetActivityTracking(null);
    },
    onRemoveActivityPlanList: function() {
      this.$refs.activityPlanList.onRemoveActivityPlanList();
    },
    // processing
    onAddMaintenanceProcessing: function() {
      this.$refs.activityPlanList.onAddMaintenanceProcessing()
    },
    // handle tab history
    onChangeHistoryTab: function(value) {
      this.historyTabSelect = value
      this.search.isGetHistory = true
      this.search.searchText = utils.getCleanStringValue(this.search.searchText)
      switch (value) {
        case Enum.MaintenanceStatusEnum.MAINTENANCE_PLANNING:
          if (this.$refs.activityPlanList !== undefined) {
            this.$refs.activityPlanList.onRefreshData(this.search);
          }
          break;
        case Enum.MaintenanceStatusEnum.MAINTENANCE_IN_PROCESSING:
          this.getMaintenanceList(1);
          break;
        default:
          break;
      }
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "GET_MAINTENANCE_LIST",
      "POST_APPROVAL_OR_NOT_APPROVAL_MAINTENANCE",
      "GET_MAINTENANCE_TYPE_LIST",
      "GET_ASSET_LIST_V2",
      "GET_USER_LIST",
      "DELETE_MAINTENANCE",
      "ON_SHOW_TOAST"
    ])
  },
  mounted() {
    // fix show multiple modal
    $(document).on("hidden.bs.modal", ".modal", function() {
      $(".modal:visible").length && $(document.body).addClass("modal-open");
    });
    //
    // this.onSearchMaintenance();
    this.onChangeTab(Enum.MaintenanceStatusEnum.MAINTENANCE_TRACKING);
    //
    this.getAssetList();
    this.getMaintenanceTypeList();
    this.getUserList();
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    confirm: Confirm,
    paginator: Paginator,
    loading: Loading,
    MaintenanceModal,
    "lte-modal": LTEModal,
    "date-picker": datePicker,
    ActivityTrackingList,
    ActivityPlanList
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.package-table {
  table-layout: fixed;
}

.package-table-td {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.customer-type-class {
  padding: 5px 15px;
  cursor: pointer;
}
.border-right {
  border-right: 1px solid #000000 !important;
}
.customer-type-select {
  font-weight: bold;
  color: #006ad4;
}
/*  */
.disable-btn {
  color: #7d7d7d;
  cursor: no-drop;
}
.detail-service {
  color: #006ad4;
}
.completed-status {
  color: green;
}
.payment-status {
  color: blue;
}
.cancel-status {
  color: red;
}
.hover-action {
  cursor: pointer;
}
.hover-action:hover {
  text-decoration: underline;
  // font-weight: bold;
}
.action-space-border {
  margin: 0 3px;
}
.table-responsive
  :deep(
  .b-table
  .description-width
  .description-content-width) {
  width: 15%;
}
.table-responsive :deep(.b-table .maintenance-cancel-class-bg) {
  background: #f5c6cb;
}
.add-maintenance-process-item:hover {
  background: #dfdfdf;
}
</style>



// WEBPACK FOOTER //
// src/views/Property/MaintenanceList.vue